import GoalCanvasView from './components/GoalCanvasView';
import { goalPaneFRELabel } from './components/GoalFRECallout.locstring.json';
import type { GoalPayload } from './schema';
import getDueDate from './util/getDueDate';
import { ControlIcons } from 'owa-control-icons';
import { formatMonthDayYear } from 'owa-datetime';
import { LightningId } from 'owa-lightning-v2';
import loc from 'owa-localize';
import { AssetAriaLabel, registerAsset, DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import {
    goalAssetName,
    goalAssetError,
    goalAssetTooltip,
    goalAssetNoTitle,
    ariaLabelGoalDescription,
    ariaLabelGoalDue,
    ariaLabelGoalNoDate,
    ariaLabelGoalComplete,
    ariaLabelGoalIncomplete,
} from './goal.locstring.json';

const GOAL_TYPE = 'goal';

export default registerAsset<GoalPayload>({
    type: GOAL_TYPE,
    iconName: ControlIcons.Bullseye,
    getToolName: () => loc(goalAssetName),
    getTooltip: () => loc(goalAssetTooltip),
    getErrorMessage: () => loc(goalAssetError),
    unsupportedDefaultCommands: [DefaultCommand.DueDate],
    CanvasView: GoalCanvasView,
    createEmptyAsset: () => ({
        type: GOAL_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH,
        payload: {},
    }),
    getAriaLabel: (payload: GoalPayload) => {
        const title = getGoalTitle(payload);
        const dueDate = getDueDate(payload.date, payload.tz);
        const formattedDueDate = dueDate
            ? loc(ariaLabelGoalDue, formatMonthDayYear(dueDate))
            : loc(ariaLabelGoalNoDate);
        const status = payload.isCompleted
            ? loc(ariaLabelGoalComplete)
            : loc(ariaLabelGoalIncomplete);

        const assetDescription = loc(ariaLabelGoalDescription, title, formattedDueDate, status);
        return loc(AssetAriaLabel.assetAriaLabel, loc(goalAssetName), assetDescription);
    },
    getTitleString: getGoalTitle,
    getSearchString: getGoalTitle,
    lightningId: LightningId.OutlookSpacesGoalsPaneFRE,
    inAppMessage: goalPaneFRELabel,
});

function getGoalTitle(payload: GoalPayload) {
    return payload.title ? payload.title : loc(goalAssetNoTitle);
}
